export default "__VITE_ASSET__DL6Obs45__"